import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

import {
    IForgotPasswordFormInputs,
    IPasswordApiResponse,
    IResetPasswordFormInputs,
} from "../utils/password.types";

/**
 * Reset Password Thunk.
 */
export const resetPassword = createAsyncThunk(
    'password/resetPassword',
    async (resetPasswordReqData: IResetPasswordFormInputs): Promise<IPasswordApiResponse> => {
        const response = await  axios.post('/api/v1/resetPassword', resetPasswordReqData);
        
        return response.data
    }
);

/**
 * Forgot Password Thunk.
 */
export const forgotPassword = createAsyncThunk(
    'password/forgotPassword',
    async (forgotPasswordReqData: IForgotPasswordFormInputs, thunkApi): Promise<IPasswordApiResponse> => {
        try {
            const response = await axios.post('/api/v1/forgotPassword', forgotPasswordReqData);

            return response.data
        } catch (error: any) {
            // Carry the API's reason through (e.g. the email isn't verified).
            return thunkApi.rejectWithValue(error.response?.data) as any;
        }
    }
);
